export function parseDpatGapsFromComment(comment) {
  const dddp = comment?.dddpData || {};
  if (dddp.gapIssues != null || dddp.gapRecommendation != null) {
    return {
      issues: String(dddp.gapIssues || "").trim(),
      recommendation: String(dddp.gapRecommendation || "").trim(),
    };
  }

  const raw = String(comment?.gaps || "").trim();
  if (!raw) return { issues: "", recommendation: "" };

  const issuesMatch = raw.match(/^Issues:\s*([\s\S]*?)(?:\n\nRecommendation:|$)/i);
  const recMatch = raw.match(/Recommendation:\s*([\s\S]*)$/i);

  if (issuesMatch || recMatch) {
    return {
      issues: (issuesMatch?.[1] || "").trim(),
      recommendation: (recMatch?.[1] || "").trim(),
    };
  }

  return { issues: raw, recommendation: "" };
}

export function formatDpatGapsField(issues, recommendation) {
  const issueText = String(issues || "").trim();
  const recText = String(recommendation || "").trim();
  if (!issueText && !recText) return "";
  if (!recText) return issueText;
  if (!issueText) return `Recommendation:\n${recText}`;
  return `Issues:\n${issueText}\n\nRecommendation:\n${recText}`;
}

export function hasDpatGapsContent(issues, recommendation) {
  return Boolean(String(issues || "").trim() || String(recommendation || "").trim());
}

export function commentHasGaps(comment) {
  const { issues, recommendation } = parseDpatGapsFromComment(comment);
  return hasDpatGapsContent(issues, recommendation);
}

export function mergeDddpDataForComment(existingComment, data, tableCommentedId, gapFields = null) {
  const base = { ...(existingComment?.dddpData || {}), indicator: tableCommentedId, tables: data };
  if (gapFields) {
    base.gapIssues = gapFields.issues;
    base.gapRecommendation = gapFields.recommendation;
  }
  return base;
}
